class SendAssessmentResultsModalController {
    constructor() {
        // this.jobMatchDetailsArray = this.resolve.jobMatchDetailsArray;
        // this.sendResultsArray = this.resolve.sendResultsArray;
    }
    $onInit() {
        this.jobMatchDetailsArray = this.resolve.jobMatchDetailsArray;
        this.sendResultsArray = this.resolve.sendResultsArray;
        this.label = 'Send Assessment Results';
        this.callbackObject = { callbackType: 'cancel', entity: {} };
        angular.forEach(this.sendResultsArray, (val, key) => {
            let jobMatchInfo = _.find(this.jobMatchDetailsArray, { 'jobMatchId': val.jobMatchId });
            val.name = jobMatchInfo.jobMatchData.name;
        });
    }
    closeModal() {
        this.callbackObject.callbackType = "close";
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
}
// import * as TEMPLATE from './send-assessment-results-modal.html;
import * as TEMPLATE from 'raw-loader!./send-assessment-results-modal.html';
export const SendAssessmentResultsModalComponent = {
    selector: 'sendAssessmentResultsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: SendAssessmentResultsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/sendAssessment/sendAssessmentResultsModal/send-assessment-results-modal.html',
    }
};
//# sourceMappingURL=send-assessment-results-modal.component.js.map